// Props para que un elemento no nativo (div, span, tr) que ya responde al clic
// se pueda operar con teclado: role, tabIndex y Enter/Espacio. El foco visible
// lo pone la regla global :focus-visible. Uso: <div {...clicable(alActivar, {label})}>.
// Si el elemento contiene botones, casillas o enlaces, no se le da role
// (anidaría controles): se pasa { role: null } y solo gana foco y teclado en el
// propio contenedor; los controles de dentro siguen siendo sus propios botones.
export function clicable(alActivar, { label, expanded, pressed, activo = true, role = "button" } = {}) {
  if (!activo) return {};
  const props = {
    tabIndex: 0,
    onClick: alActivar,
    onKeyDown: e => {
      if (e.target !== e.currentTarget) return;
      if (e.key === "Enter" || e.key === " ") { e.preventDefault(); alActivar(e); }
    },
  };
  if (role) props.role = role;
  if (label) props["aria-label"] = label;
  if (role && expanded !== undefined) props["aria-expanded"] = expanded;
  if (role && pressed !== undefined) props["aria-pressed"] = pressed;
  return props;
}
